import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import Header from "../components/Header";
import List from "../components/List";
import styles from "../assets/css/InConfirmation.module.css";
import { BASE_URL } from "../constants/constants";

const InConfirmation = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState({});
  const { id } = useParams();
  const token = localStorage.getItem("token");

  const headers = {
    Authorization:
      `Bearer ${token}`,
  };

  const getUser = (id) => {
    axios
      .get(`${BASE_URL}/v0/users/manual-verify/${id}`, { headers })
      .then((response) => {
        console.log("User data:", response.data.result);
        setUser(response.data.result);
      })
      .catch((error) => {
        console.error("There was an error fetching the user!", error);
      });
  };

  useEffect(() => {
    if (id) {
      getUser(id);
    }
  }, [id]);

  return (
    <div>
      <Header />
      <div className={styles.container}>
        <List />
        <div className={styles.container1}>
          <div className={styles.box}>
            <div
              onClick={() => navigate("/verification")}
              className={styles.text}
            >
              Верификация пола
            </div>
            <img
              className={styles.nexticon}
              src="/images/next.svg"
              alt="next icon"
            />
            <div className={styles.text1}>
              {user.firstName || "Пользователь"}
            </div>
          </div>
          <div className={styles.container2}>
            <div className={styles.box1}>
              <div className={styles.text2}>
                {user.firstName || "Пользователь"}
              </div>
              <button className={styles.confirmationbtn}>Подтвердить</button>
            </div>
            <div className={styles.boxuser}>
              <img
                className={styles.image}
                src={`${BASE_URL}/v0/${user.image1}`}
                alt="User image 1"
              />
              {/* <img className={styles.image} src={`${BASE_URL}/v0/${user.image2}`} alt="User image 2" /> */}

              <div className={styles.box5}>
                <div className={styles.text3}>Данные пользователя</div>
                <div className={styles.box6}>
                  <div className={styles.type}>Номер телефона:</div>
                  <div className={styles.type1}>{user.phoneNumber}</div>
                </div>
                <div className={styles.box6}>
                  <div className={styles.type}>Дата регистрации:</div>
                  <div className={styles.type1}>{new Date(user.createdAt).toLocaleDateString()}</div>
                </div>
              </div>
            </div>
            <div className={styles.box2}>
              <button
                onClick={() => navigate("/verification")}
                className={styles.deletebtn}
              >
                Назад
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InConfirmation;
